export default "__VITE_ASSET__6e0a6e91__"